import { BaseIllustration, BaseIllustrationProps } from '../BaseIllustration';

export type CraneIllustrationProps = Omit<BaseIllustrationProps, 'children'>;

export const CraneIllustration = ({ ...props }: CraneIllustrationProps) => (
  <BaseIllustration width="64" height="64" viewBox="0 0 64 64" {...props}>
    <g strokeWidth={2} strokeMiterlimit="10" strokeLinecap="square" strokeLinejoin="miter" fill="none">
      <rect x="48" y="42" width="12" height="6" />
      <line x1="54" y1="28" x2="54" y2="42" />
      <polyline points="23 23 23 59 14 59 14 23" />
      <line x1="6" y1="59" x2="31" y2="59" />
      <polyline points="27 14 60 17 60 23 4 23 4 16 10 14" strokeLinecap="butt" />
      <line x1="23" y1="23" x2="14" y2="32" strokeLinecap="butt" />
      <line x1="23" y1="41" x2="14" y2="50" strokeLinecap="butt" />
      <line x1="23" y1="41" x2="14" y2="32" strokeLinecap="butt" />
      <line x1="23" y1="59" x2="14" y2="50" strokeLinecap="butt" />
      <polyline points="10 23 10 5 24 5 27 14 27 23" />
      <path d="M16,5v5a4,4,0,0,0,4,4h7" strokeLinecap="butt" />
    </g>
  </BaseIllustration>
);

CraneIllustration.displayName = 'CraneIllustration';
